/*
 * File: StudentDriveUtilities.ts
 * Author: Austin Robinson
 * Date Created: 4/18/2022
 * Copyright (c) DrivingDoc 2022
 */
import { CoursePeriod } from 'api/hooks/private/periods/GetCoursePeriod.ts';

const getPeriodNumber = (
  period_id: string,
  period_enrollments: CoursePeriod['period_enrollments'][number]['student']['period_enrollments'],
  prependToNumber = '',
  canceledText = 'C',
) => {
  if (!period_enrollments) {
    return `${prependToNumber}1`;
  }
  const sorted = period_enrollments.sort((a, b) => (a.course_period.start > b.course_period.start ? 1 : -1));

  const filtered = sorted.filter((registration) => {
    if (
      !registration.canceled_at &&
      !registration.course_period.deleted &&
      (registration.attendance === 'present' || !registration.attendance)
    ) {
      return true;
    }
    return false;
  });

  const periodNum = filtered.findIndex((period) => period.course_period_id === period_id);

  if (periodNum !== -1) {
    return `${prependToNumber}${periodNum + 1}`;
  }

  const period = period_enrollments.find((period) => period.course_period_id === period_id);
  if (period?.canceled_at) {
    return canceledText;
  }
  switch (period?.attendance) {
    case 'absent':
      return 'AB';
    case 'no_permit':
      return 'NP';
    default:
      return '';
  }
};

export default getPeriodNumber;
